
// services/auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import { BehaviorSubject, Observable,throwError } from 'rxjs';
import { User } from '../../objects/user';
import { environment } from '../../environments/environment';  
   
import { catchError, map } from 'rxjs/operators';
 
//"http://propcity.us/api/"//  
 
interface LoginDto {
  username: string;
  password: string;
}

 

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentUserSubject = new BehaviorSubject<User | null>(null);
  public currentUser$ = this.currentUserSubject.asObservable();
 
  apiUrl =  environment.apiUrl; 
 
  constructor(private http: HttpClient) {
    // Check if user is logged in on service initialization
    const userData = localStorage.getItem('currentUser');
    if (userData) {
      this.currentUserSubject.next(JSON.parse(userData));
    }
  }

  
  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An error occurred during authentication';
    
    if (error.status === 401) {
      errorMessage = 'Invalid username or password';
    } else if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Server Error: ${error.status} ${error.message}`;
    }
    
    return throwError(() => new Error(errorMessage));
  }

  login(email: string, password: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/auth/login`, { email, password });
  }


  authenticateUser(login: LoginDto): Observable<User> {
    return this.http.post<User>(this.apiUrl, login)
      .pipe(
        map(response => {
          // Handle successful authentication
          return response;
        }),
        catchError(this.handleError)
      );
  }


  register(userData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/auth/register`, userData);
  }


   createUser(user: User): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'RequestVerificationToken': this.getAntiForgeryToken()  // Optional, for CSRF token
    });
    console.log("user:" +  user)

    return this.http.post<any>(this.apiUrl + "Users/Register", user, { headers });
  }

   // OPTIONAL: method to get the Anti-Forgery token from meta tag
  private getAntiForgeryToken(): string {
    const tokenElement = document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement;
    return tokenElement ? tokenElement.value : '';
  }
   

 logout() {
    this.currentUserSubject.next(null);
    sessionStorage.removeItem('currentUser');
    // setCurrentUser persists to localStorage, so clear it too or the user is
    // silently logged back in on the next page load.
    localStorage.removeItem('currentUser');
  }
  getCurrentUser() {
    return this.currentUserSubject.value;
  }

  setCurrentUser(user: User): void {
    localStorage.setItem('currentUser', JSON.stringify(user));
    this.currentUserSubject.next(user);
  }

  socialLogin(
    provider: 'google' | 'apple',
    token: string,
    firstName?: string | null,
    lastName?: string | null
  ): Observable<User> {
    return this.http.post<User>(`${this.apiUrl}Users/SocialLogin`, {
      provider,
      token,
      firstName: firstName ?? null,
      lastName: lastName ?? null,
    });
  }
}
